import { styled } from '@mui/system';
import { Box, Typography, Button, IconButton } from '@mui/material';

export const HeaderText = styled(Typography)(({ theme }) => ({
  color: theme.colors.gray,
}));

export const EmployeeButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: theme.spacing(1),
  marginBottom: theme.spacing(1),
  backgroundColor: theme.palette.background.secondary,
  color: theme.palette.text.primary,
  textAlign: 'left',
  '&:hover': {
    backgroundColor: theme.palette.background.secondaryHover,
  },
}));

export const EmployeeInfo = styled(Box)(({ theme }) => ({
  gap: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
}));

export const EmployeeDetails = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));

export const RoleText = styled(Typography)(({ theme }) => ({
  color: theme.colors.gray,
}));

export const StyledBackButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
}));

export const EmployeeListContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const EmployeeDisplayContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
}));

export const SearchContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));
